<template>
  <div class="work-list">
    <ul>
      <li
        v-for="(item, index) in list"
        :key="index"
        @click="handeSelected(item)"
        :class="{ selected: item.uid == selected }"
      >
        <div>
          <div class="radio">
            <i></i>
          </div>
          <div class="img-layout">
            <img :src="$$viewImage(item.headImage, 150, 150)" alt="" />
          </div>
          <div class="content">
            <h3 class="name-grade">
              <span>{{ item.workerName }}</span>
              <i :class="[identityLabelObj(item).icon]"></i>
            </h3>
            <p>
              <span>50岁</span
              >&nbsp;|&nbsp;<span>江苏人</span>&nbsp;|&nbsp;<span>从业</span>
            </p>
            <div class="price"><b></b>&yen;123112 <span>/26天</span></div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import waiter from '@/components/user/profile_confirm'
import { identityLabel } from '@/plugins/enum'

export default {
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      list: [],
      selected: 0
    }
  },
  computed: {
    ...mapState('confirmYuesao', ['depList']),
    ...mapState(['workers', 'viewName'])
    // workers_on() {
    //     let list = this.workers.available && this.workers.available.workerList
    //     list = this.getWorkersList(list)
    //     const {store_code } = this.confirmSelected.store
    //     if(store_code) {
    //         return list.filter(item =>item.storeCode == store_code)
    //     } else {
    //         return list
    //     }

    // },
  },
  mounted() {
    try {
      const city = this.depList.find(item => item.id == 'cs')
      const grade = this.depList.find(item => item.id == 'dj')
      const yusao = this.depList.find(item => item.id == 'ys')
      this.getWorkersList(city, grade, yusao)
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapMutations('confirmYuesao', ['setSelected']),
    getWorkersList(city, grade, yusao) {
      this.list = this.workers.available && this.workers.available.workerList
    },

    identityLabelObj(item) {
      return identityLabel(item.userTypeName || '')
    },
    handeSelected(item) {
      this.selected = item.uid
      this.setSelected({ id: 'ys', value: item })
      this.$router.go(-1)
    }
  },
  components: {
    waiter
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.work-list {
  background-color: #e9e9e9;
  min-height: 100vh;
  padding: rem(20px) rem(24px);
  ul {
    background: #fff;
    overflow: hidden;
    border-radius: rem(16px);
    li {
      padding: 0 rem(24px);
      > div {
        display: flex;
        align-items: stretch;
        padding: rem(32px) 0;
        @include border(bottom);
        .radio {
          flex: none;
          display: flex;
          align-items: center;
          justify-content: center;
          width: rem(57px);
          i {
            width: 100%;
            height: 100%;
            background: url('~@/assets/images/evaluate/jingqi_selected_n@3x.png')
              no-repeat left center;
            background-size: rem(38px) rem(38px);
          }
        }
        .img-layout {
          flex: none;
          width: rem(150px);
          height: rem(150px);
          overflow: hidden;
          border-radius: rem(8px);
          margin-right: rem(20px);
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .content {
          display: flex;
          flex: auto;
          flex-direction: column;
          justify-content: space-between;
          > p {
            font-size: rem(26px);
            color: #666666;
            line-height: rem(32px);
          }
          .price {
            font-size: rem(24px);
            color: #ff5900;

            line-height: rem(30px);
          }
        }
      }
      h3 {
        display: flex;
        span {
          font-size: rem(30px);
          color: #333333;

          line-height: rem(40px);
        }
        i {
          display: inline-block;
          height: rem(50px);
          background-position: right top;
          width: rem(220px);
          background-repeat: no-repeat;
          &.signed-two {
            background-image: url('~@/assets/images/lab_ys_two.png');
            background-size: rem(158px) auto;
          }
          &.signed-three {
            background-image: url('~@/assets/images/lab-ys-three@3x.png');
            background-size: rem(158px) auto;
          }
          &.signed-four {
            background-image: url('~@/assets/images/lab-ys-four@3x.png');
            background-size: rem(158px) auto;
          }
          &.signed-five {
            background-image: url('~@/assets/images/lab-ys-five@3x.png');
            background-size: rem(158px) auto;
          }
          &.signed-gold {
            background-image: url('~@/assets/images/lab-ys-gold@3x.png');
            background-size: rem(161px) auto;
          }
          &.signed-senior {
            background-image: url('~@/assets/images/lab-ys-zs@3x.png');
            background-size: rem(162px) auto;
          }
          &.signed-diamond {
            background-image: url('~@/assets/images/lab_ys_diamond.png');
            background-size: rem(158px) auto;
          }
          &.joint {
            background-image: url('~@/assets/images/lab-ys-joint@3x.png');
            background-size: rem(120px) auto;
          }
          &.cert {
            background-image: url('~@/assets/images/lab-yrs@3x.png');
            background-size: rem(187px) auto;
          }
        }
      }
      &.selected {
        > div {
          .radio i {
            background-image: url('~@/assets/images/evaluate/jingqi_selected@3x.png');
          }
        }
      }
    }
  }
}
</style>
